import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { PayGateMpiResponse } from '@parkupp/core'
import { HttpClient } from '@angular/common/http'
import { AuthenticationService } from '../../../../services/authentication.service'
import { ClientService } from '../../../../services/client.service'
import { PaymentService } from '../../../../services/payment.service'

@Component({
    selector: 'app-paygate-result-page',
    templateUrl: './paygate-result-page.component.html',
    styleUrls: ['./paygate-result-page.component.scss'],
})
export class PaygateResultPageComponent implements OnInit {
    payGateMpiResponse: PayGateMpiResponse

    constructor(
        private paymentService: PaymentService,
        public authService: AuthenticationService,
        private clientSvc: ClientService,
        private route: ActivatedRoute,
        private http: HttpClient,
        private authenticationService: AuthenticationService
    ) {}

    ngOnInit() {
        this.payGateMpiResponse = new PayGateMpiResponse({
            payRequestId: this.route.snapshot.queryParamMap.get('PAY_REQUEST_ID') as any,
            transactionStatus: this.route.snapshot.queryParamMap.get('TRANSACTION_STATUS') as any,
            checksum: this.route.snapshot.queryParamMap.get('CHECKSUM'),
        })

        this.clientSvc.activeClientReady.subscribe((activeClient: any) => {
            if (this.clientSvc.activeClient) {
                this.paymentService.httpFollowupRequest(activeClient, this.payGateMpiResponse).then(() => {
                    this.informParent()
                })
            }
        })
    }

    informParent(): void {
        // Client the popup
        window.parent.postMessage({ action: 'closeMpi' })
    }
}
